<template>
  <v-container fluid>
    <v-card :loading="loadingMachineInfo" flat :disabled="loadingMachineInfo">
      <v-card-title>
        {{ $t("machines.info.title") }}
        <div class="ml-auto">
          <!-- Refresh Button -->
          <v-tooltip top>
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="fetchData"
                :loading="loadingMachineInfo"
                :disabled="loadingMachineInfo || isEditing"
                class="text-subtitle-1"
                color="primary"
                icon
              >
                <v-icon>mdi-cached</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("common.actions.refresh") }}</span>
          </v-tooltip>

          <!-- Edit Button -->
          <v-tooltip top v-if="isAdmin">
            <template v-slot:activator="{ on, attrs }">
              <v-btn
                v-bind="attrs"
                v-on="on"
                @click="isEditing = true"
                :disabled="loadingMachineInfo || isEditing"
                class="text-subtitle-1"
                color="primary"
                icon
              >
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </template>
            <span>{{ $t("machines.info.actions.edit") }}</span>
          </v-tooltip>
        </div>
      </v-card-title>
      <v-card-text>
        <v-form v-model="valid" ref="editMachineInfoForm">
          <v-row>
            <v-col>
              <MachineOrder
                :machineInfo.sync="machineInfoInner"
                :isEditing="isEditing"
              />
            </v-col>
            <v-col>
              <MachineWarranty
                :machineInfo.sync="machineInfoInner"
                :isEditing="isEditing"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col>
              <MachineSegment
                :loading="loadingMachineInfo"
                :machineInfo.sync="machineInfoInner"
                :isEditing="isEditing"
                :machine="machine"
              />
            </v-col>
          </v-row>
        </v-form>
      </v-card-text>
      <v-card-actions v-if="isEditing">
        <v-spacer></v-spacer>

        <v-btn
          :loading="loadingMachineInfo"
          :disabled="loadingMachineInfo || !valid"
          @click.stop="onSaveClick"
          class="bg-details_background"
        >
          {{ $t("common.actions.save") }}
        </v-btn>

        <v-btn
          :loading="loadingMachineInfo"
          :disabled="loadingMachineInfo"
          @click.stop="onCancelClick"
          class="bg-details_background"
        >
          {{ $t("common.actions.cancel") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-container>
</template>

<script>
import MachineOrder from "@/components/machines/MachineOrder"
import MachineWarranty from "@/components/machines/MachineWarranty"
import MachineSegment from "@/components/machines/MachineSegment"
import { mapGetters } from "vuex"

import formatter from "@/utils/formatter"

export default {
  props: ["machine"],
  components: { MachineOrder, MachineWarranty, MachineSegment },
  data() {
    return {
      machineInfoInner: {},
      isEditing: false,
      valid: false
    }
  },
  watch: {
    machineInfo(newVal) {
      if (!this.isEditing && newVal) {
        this.machineInfoInner = {
          ...newVal,
          warrantyStartDate: this.formatDate(newVal.warrantyStartDate),
          warrantyEndDate: this.formatDate(newVal.warrantyEndDate),
          deliveryDate: this.formatDate(newVal.deliveryDate),
          commissioningDate: this.formatDate(newVal.commissioningDate)
        }

        // TODO DEBUG!!!
        // this.isEditing = true
      }
    }
  },
  computed: {
    ...mapGetters(["loadingMachineInfo", "machineInfo", "isAdmin"]),
    order() {
      return {
        orderNumber: this.machineInfo?.orderNo,
        orderType: this.machineInfo?.orderType,
        deliveryDate: this.formatDate(this.machineInfo?.deliveryDate),
        commissioningDate: this.formatDate(this.machineInfo?.commissioningDate)
      }
    },
    warranty() {
      let warrantyLength = "-"
      if (this.machineInfo?.warrantyLength) {
        warrantyLength = this.$tc(
          "common.units.month",
          this.machineInfo?.warrantyLength
        )
      }
      return {
        startDate: this.formatDate(this.machineInfo?.warrantyStartDate),
        endDate: this.formatDate(this.machineInfo?.warrantyEndDate),
        length: warrantyLength
      }
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    formatDate(dateStr) {
      if (dateStr) {
        return formatter(this.$i18n).formatDate(new Date(dateStr))
      }
      // return "-"
      return null
    },
    fetchData() {
      this.$store.dispatch("fetchMachineInfo", {
        tenantUid: this.machine.tenantUid,
        serialNo: this.machine.serialNo
      })
    },
    async onSaveClick() {
      if (!this.$refs.editMachineInfoForm.validate()) {
        return
      }

      const req = {
        machine: this.machine,
        machineInfo: this.machineInfoInner
      }

      try {
        await this.$store.dispatch("updateMachineInfo", req)
        this.fetchData()
        this.isEditing = false
      } catch (ex) {
        // Already displayed in main error handler
      }
    },
    onCancelClick() {
      this.fetchData()
      this.isEditing = false
    }
  }
}
</script>
